//引入axios 
import request from '../utils/request'// 这里是引入咱们的axios用axios来进行异步接口请求
// 获取腾讯云im 授权
export function getUserSig(data){
    return request({
        url:'/api/tenim/getUsersig',
        method:'post',
        data, 
    })
}
//创建会话
export function createSession(data){
    return request({
        url:'/api/ztim/createSession',
        method:'post',
        data, 
    })
}
//会话列表
export function sessionList(data){
    return request({
        url:'/api/ztim/sessionList',
        method:'post',
        data, 
    })
}
//历史消息
export function messageList(data){
    return request({
        url:'/api/ztim/messageList',
        method:'post',
        data, 
    })
}
//发送消息
export function sendmesg(data){
    return request({
        url:'/api/ztim/send',
        method:'post',
        data, 
    })
}
// 
export function judgeSendMsg(data){
    return request({
        url:'/api/ztim/judgeSendMsg',
        method:'post',
        data, 
    })
}
